import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ModalController} from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';

/**
 * Generated class for the ModalsEngineselectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modals-usersedit',
  templateUrl: 'modals-usersedit.html',
})
export class ModalsUserseditPage {
  private loading;
  public data;
  public buckets;

  activeengine: number;
  status: boolean = false;
  prevEngine = localStorage.getItem('engine') == null ? 'Autodesk.Revit+2020' : localStorage.getItem('engine');
  bucketList = [];
  id;
  name;
  organization;
  login;
  pass;
  role;
  public bucket: any;
  bucketname;
  check = false;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public loadingController: LoadingController, public modalCtrl: ModalController,
    private rest: RestProvider,
    public navParam: NavParams) {
      this.data = this.navParam.get('data');
      if(this.data != null) {
        this.role = this.data.role;
        this.id = this.data.id;
        this.name = this.data.name;
        this.organization = this.data.organization;
        this.login = this.data.username;
        this.pass = this.data.password;
        // this.bucket = this.data.bucket_id;
        if(this.data.bucket_id != null) {
          this.bucket = this.data.bucket_id.split(',');
        }
        this.bucketname = this.data.bucket_name;
        this.check = true;
      }
      this.buckets = this.navParam.get('buckets');
      console.log(this.buckets);
  }

  ionViewDidLoad() {

  }
  dismiss() {
    this.navCtrl.pop();
  }

  getBuckets(event) {
    console.log(event);
    this.bucket = event;
  }

  insertOrUpdate() {
    console.log('id           => ', this.id);
    console.log('name         => ', this.name);
    console.log('organization => ', this.organization);
    console.log('username     => ', this.login);
    console.log('password     => ', this.pass);
    console.log('role         => ', this.role);
    console.log('bucket       => ', this.bucket);
    console.log('type         =>',typeof this.id == 'undefined' ? 'create' : 'update');
    if(typeof this.id == 'undefined') console.log('undefined baina;');
    let bucketIds = '';
    if(typeof this.bucket == 'undefined') {
      console.log('undefined bshdee');
    } else {
      for(let i = 0; i < this.bucket.length;i++){
        bucketIds = bucketIds + this.bucket[i].toString();
        if(i < (this.bucket.length) - 1) {
          bucketIds = bucketIds + ',';
        }
      }
    }
    
    this.rest.updateuser(typeof this.id == 'undefined' ? null : this.id, this.name, this.login, this.pass, this.role, this.organization, bucketIds, typeof this.id == 'undefined' ? 'create' : 'update').subscribe( response => {
      console.log('this is da responseee => ',response);
      this.dismiss();
    });
  }
  
  onChange(value){
    this.role = value;
  }


}



// WEBPACK FOOTER //
// ./src/pages/modals-usersedit/modals-usersedit.ts